import store from "../store";
import { actionTypes } from "./saga";

/**
 * @module ProfileSaga
 */

/**
 *
 * @param {profiles} payload profile data
 */
export function setAccountProfiles(profiles) {
  store.dispatch({
    type: actionTypes.SET_ACCOUNT_PROFILES,
    payload: {
      profiles: profiles,
    },
  });
}
export function updateProfileAction(file, data) {
  store.dispatch({
    type: actionTypes.UPDATE_PROFILE,
    payload: {
      picture: file,
      profileData: data,
    },
  });
}

export function updatePasswordAction(data) {
  store.dispatch({
    type: actionTypes.UPDATE_PASSWORD,
    payload: data,
  });
}
